/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
// eslint-disable-next-line jira/restricted/unsafe-global-state-stores
import { useJiraWorkmanagementProjectNavigation } from '@jira/navigation-apps__sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { useIsRovoAiEnabledForJiraProduct } from '@jira/router-resources__rovo-entitlement/src/useIsRovoAiEnabledForJiraProduct.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { type RouteContext, Redirect } from '@atlassian/react-resource-router';

export const ProjectSettingsRedirect = ({ match }: RouteContext): React.JSX.Element | null => {
	const { data, loading } = useJiraWorkmanagementProjectNavigation();
	const isRovoAiEnabled = useIsRovoAiEnabledForJiraProduct('JIRA');
	const { projectKey } = match.params;

	// Wait for nav data to be available before deciding where to redirect on cold loads
	if (loading || !data) {
		return null;
	}

	if (
		data?.permissionInfo?.isAdmin ||
		data?.permissionInfo?.isSiteAdmin ||
		data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS
	) {
		return <Redirect to={`/jira/core/projects/${String(projectKey)}/settings/details`} />;
	}
	if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) {
		return <Redirect to={`/plugins/servlet/project-config/${String(projectKey)}/workflows`} />;
	}
	if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) {
		return <Redirect to={`/plugins/servlet/project-config/${String(projectKey)}/issuelayout`} />;
	}
	if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) {
		return (
			<Redirect to={`/plugins/servlet/project-config/${String(projectKey)}/administer-versions`} />
		);
	}

	// Non-admin members with the Space Agents experiment (and non-admin view gate) land on the
	// Agents-only settings surface instead of `/settings/details`, which the settings guard bounces
	// non-admins away from. Also requires Rovo AI entitlement for JIRA.
	if (
		// eslint-disable-next-line jira/ff/no-preconditioning
		fg('space-agent-settings-allow-non-admin-view') &&
		isRovoAiEnabled &&
		expVal('yamato-agents-home-space-settings-beta', 'isEnabled', false)
	) {
		return <Redirect to={`/jira/core/projects/${String(projectKey)}/settings/agents`} />;
	}

	return (
		<Redirect to={`/jira/core/projects/${String(match.params.projectKey)}/settings/details`} />
	);
};
